import React from 'react';
import AdminV2Tournaments from '../../admin-v2/tournaments';

/** Manager V2 Tournaments — read-only list. Feature : pages.tournaments.manager. */
const ManagerV2Tournaments = () => (
  <AdminV2Tournaments basePath="/manager/tournaments" readOnly />
);

export default ManagerV2Tournaments;
